import React from 'react';
import 'components/SectionLabel/sectionLabel.scss';

const SectionLabel = ({ children }) => <h3 className="section-label">{children}</h3>;

export default SectionLabel;
